const requestTime = {
  requestMili: 10000,
  requestSeg: 10,
};
export default requestTime;
